var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('inline-svg',{class:[
		'close', 
		{ 
			active: this.sharedStore.state.viewingProject && _vm.$route.path !== '/about'
		}
	],attrs:{"src":_vm.closeSvg,"tabindex":_vm.focusable,"role":"button"},on:{"click":_vm.exitProject}}),_c('div',{class:[
		'squiggle', 
		{ 
			shrink: this.sharedStore.state.viewingProject,
			'shrink-about': _vm.$route.path == '/about'
		}
	]}),_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Work")]),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }